import { render } from "./Sidemenu.vue?vue&type=template&id=6145ddd6&scoped=true"
import script from "./Sidemenu.vue?vue&type=script&lang=js"
export * from "./Sidemenu.vue?vue&type=script&lang=js"

import "./Sidemenu.vue?vue&type=style&index=0&id=6145ddd6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6145ddd6"]])

export default __exports__